import {FC} from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from 'recharts';
import {styled} from 'styled-components';
import {PuffLoader} from 'react-spinners';
import {cssOverride} from '../../../../utils/const';
import {colors} from '../../../../styles';
import {useSelector} from 'react-redux';
import {reportsSelect} from '../../../../entities/reports';

export const BarChartAbc: FC = () => {
    const {reportAbc} = useSelector(reportsSelect);

    if (!reportAbc) {
        return <PuffLoader color={colors.loader} cssOverride={cssOverride} />;
    }

    const CustomTooltip = ({active, payload, label}: any) => {
        if (active && payload && payload.length) {
            const dataItem = reportAbc?.chart?.find(
                (item) => item.range === label
            );
            return (
                <TooltipWrapper>
                    <p style={{color: dataItem?.color, fontWeight: 'bold'}}>
                        {`Продукт: ${label}`}
                    </p>
                    <p style={{color: colors.grey}}>
                        {`Продажи: ${payload[0].value.toLocaleString(
                            'ru-RU'
                        )} ₽`}
                    </p>
                </TooltipWrapper>
            );
        }
        return null;
    };

    return (
        <ChartContentWrapper>
            <ChartContainer>
                <div
                    style={{
                        minWidth: reportAbc?.chart?.length * 60,
                        height: '500px',
                    }}
                >
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart
                            data={reportAbc?.chart}
                            margin={{top: 20, right: 30, left: 20, bottom: 100}}
                            barSize={40}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis
                                dataKey="range"
                                angle={-45}
                                textAnchor="end"
                                tick={{fontSize: 10}}
                                interval={0}
                            />
                            <YAxis
                                width={85}
                                tickFormatter={(value) =>
                                    `${value.toLocaleString('ru-RU')}₽`
                                }
                            />
                            <Tooltip content={<CustomTooltip />} />

                            <Bar
                                dataKey="value"
                                name="Продажи"
                                radius={[4, 4, 0, 0]}
                                shape={(props) => {
                                    const {x, y, width, height, value} = props;
                                    const item = reportAbc?.chart?.find(
                                        (d) => d.value === value
                                    );
                                    const fillColor =
                                        item?.color || colors.defChart;

                                    return (
                                        <rect
                                            x={x}
                                            y={y}
                                            width={width}
                                            height={height}
                                            fill={fillColor}
                                            radius={4}
                                        />
                                    );
                                }}
                            />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </ChartContainer>
        </ChartContentWrapper>
    );
};

const ChartContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 500px;
    overflow: hidden;
`;

const TooltipWrapper = styled.div`
    padding: 10px;
    background-color: ${colors.cleanWhite};
    border-radius: 4px;
    border: 1px solid '#ccc';
`;

const ChartContainer = styled.div`
    position: relative;
    flex: 1;
    min-height: 400px;
    overflow-x: auto;
    overflow-y: hidden;

    &::-webkit-scrollbar {
        height: 8px;
    }

    &::-webkit-scrollbar-track {
        background: ${colors.bgWhite};
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
`;
